<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapGetters(
      'user',
      [
        'isUserLoggedIn',
        'accessToken',
        'jwtData'
      ]
    ),
    ...mapGetters(
      'app',
      [
        'log',
        'latestLog'
      ]
    )
  },
  watch: {
    isUserLoggedIn (newVal) {
      if (newVal) {
        let redirect = (this.$route.query.redirect) ? this.$route.query.redirect : '/'
        this.$router.push({ path: redirect })
      } else {
        this.$router.push(
          {
            path: '/admin',
            query: { redirect: this.$route.path }
          }
        )
      }
    },
    accessToken (newVal) {
      this.$axios.defaults.headers = {
        Authorization: 'Bearer ' + newVal
      }
    }
  },
  created () {
    this.$store.dispatch('user/setBearerToken')
  }
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
</style>
<style>
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue